import { create } from 'zustand';

interface UnreadState {
  chat: number;
  setChat: (count: number) => void;
}

/** Host 탭 미읽음 점(P3). 알림 벨의 서버 수는 notifications Query로만 조회한다. */
export const useUnreadStore = create<UnreadState>()((set) => ({
  chat: 0,
  setChat: (chat) => set({ chat }),
}));
